export const QUERY_KEYS = {
    PLANS: [
        "plans"
    ],
    PLAN_DETAIL: [
        "plan-detail"
    ]
};
